import { ca } from '@cian/analytics';

export function trackFullscreenOpen() {
  ca('event', {
    action: 'Open_card_fullscreen_gallery',
    category: 'card',
    name: 'oldevent',
  });
}
